import {datadogLogs} from '@datadog/browser-logs'

export default defineNuxtPlugin((nuxtApp) => {
    datadogLogs.init({
        clientToken: 'pubfbd239c453fc2ca5fa5dbad72003a767',
        site: 'datadoghq.eu',
        service: 'myefficiency-front',
        env: nuxtApp.$config.public.env,
        version: nuxtApp.$config.public.version,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
    })
});
